import { ip_back } from "../../config";

const getToken = () => localStorage.getItem("token");

function overlaysUrl() {
  return `${String(ip_back || "").replace(/\/?$/, "/")}api/tour-guide/overlays`;
}

function headers() {
  return { Authorization: getToken() || "", "Content-Type": "application/json" };
}

export async function fetchTourPlaybookOverlays() {
  const token = getToken();
  if (!token) return {};
  const res = await fetch(overlaysUrl(), { headers: headers() });
  if (!res.ok) return {};
  const json = await res.json().catch(() => ({}));
  return json?.data?.overlays || json?.overlays || {};
}

export async function saveTourPlaybookOverlays(overlays) {
  const res = await fetch(overlaysUrl(), {
    method: "PUT",
    headers: headers(),
    body: JSON.stringify({ overlays }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json?.message || "Could not save guide tours");
  }
  return json?.data?.overlays || overlays;
}

export async function resetTourPlaybookOverlay(playbookId) {
  const res = await fetch(`${overlaysUrl()}/${encodeURIComponent(playbookId)}`, {
    method: "DELETE",
    headers: headers(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json?.message || "Could not restore the default walk");
  }
  return json?.data?.overlays || {};
}
